export default "__VITE_ASSET__CNMvItPA__"